<template>
  <div>
    <PageTitle title="Hacker News: Show" />
    <PostList source="https://hacker-news.firebaseio.com/v0/showstories.json"/>
  </div>
</template>

<script>
import PostList from '@/components/PostList'
import PageTitle from '@/components/PageTitle'
export default {
  name: 'Show',
  components: {
    PageTitle,
    PostList
  }
}
</script>
